import React, { useState, useEffect } from 'react'
import Header from '../BaseComponents/Header'
import FotterMain from '../BaseComponents/FotterMain'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL, becomeDealer, OEMRegistration } from '../../networkCalls';
import SEO from '../BaseComponents/SEO';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Link } from "react-router-dom";
import { Autocomplete } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { actionTypes, useStateValue } from '../../store';
const validationSchema = yup.object({

    CompanyName: yup
        .string('Enter Your Company Name')
        .required('Company Name is a required field'),

    Address: yup
        .string('Enter your address')
        .required('Address is a required field'),
    City: yup
        .string('Enter your city')
        .required('City is a required field'),
    State: yup
        .string('Enter your state')
        .required('State is a required field'),
    PostalCode: yup
        .string('')
        .required('Postal Code is a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(6, 'Enter 6 digit Postal Code')
        .max(6, 'Enter 6 digit Postal Code'),
    Name: yup
        .string('Enter your Name')
        .required('Full Name is a required field'),
    Email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email ID is a required field'),
    Mobile: yup
        .string('')
        .required('Mobile Number a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(10, 'Enter 10 digit mobile number')
        .max(10, 'Enter 10 digit mobile number'),
    TellUsAbout: yup
        .string('Enter your state')
        .required('About your Business is a required field'),

});
const OemRegsitration = () => {
    const [{ token, huid }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [agree, setAgree] = useState(false);
    const haveAgree = (event) => {
        setAgree(event.target.checked);
    };
    const toTop = () => {
        window.scrollTo(0, 0);
    }
    useEffect(() => {
        toTop();
    }, []);

    const formik = useFormik({
        initialValues: {
            CompanyName: '',
            Address: '',
            City: '',
            State: '',
            PostalCode: '',
            Name: '',
            Mobile: '',
            Email: '',
            TellUsAbout: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            console.log('data to push', values)
            setLoading(true);
            OEMRegistration(values).then((res) => {
                setLoading(false);
                switch (res.data.status) {
                    case 1:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        resetForm({ values: '' })
                        setAgree(false)
                        return true;
                    case 0:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    default:
                        return;
                }
            });
        },
    });

    const cddl = [
        {
            value: 'india',
            label: 'India',
        },
    ];
   

    return (
        <>
            <SEO
                title="OEM Regsitration"
                description=""
                name="HIPP - Honda India Power"
                url="https://www.hondaindiapower.com/oem-registration"
                type='Website' />
            <Header />
            <div className="post-view__header post-header post-header--has-image" style={{ display: 'block' }}>
                <div className="post-header__image post-header__image-car " style={{ textAlign: 'center' }}>
                    <LazyLoadImage
                        alt=""
                        effect="blur"
                        className='img-fluid'
                        src={`https://hondaold.wipl.co.in/front/media/home-why-honda-parallax.jpg`}
                    />
                </div>
            </div>
            <div className='innerpagebg pt-5 pb-5' style={{ zIndex: '1', position: 'relative' }}>
                <div className='container pt-1 pb-5' style={{ textAlign: 'justify' }}>
                    <div className='col-lg-8 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                        <div className='card p-4 rounded-0 shadow-sm'>
                            <div className="align-items-center text-left">
                                <h3 className='d-inline-block m-0 fw-bold txtdgray'>
                                    Become An <span className='txtred'>Honda OEM</span>
                                </h3>
                            </div>
                            <p className='mt-2 f16'>Kindly enter the required information if you wish to obtain<br />authorisation as a Honda OEM.</p>
                            <hr className='mt-0' />
                            <form onSubmit={formik.handleSubmit} autoComplete="off">
                                <div className='row'>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="CompanyName"
                                            name="CompanyName"
                                            label="Company Name *"
                                            InputLabelProps={{ shrink: true }}
                                            type="text"
                                            value={formik.values.CompanyName}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("CompanyName", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.CompanyName && Boolean(formik.errors.CompanyName)}
                                            helperText={formik.touched.CompanyName && formik.errors.CompanyName}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="Address"
                                            name="Address"
                                            label="Address *"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            value={formik.values.Address}
                                            onChange={(e) => {
                                                formik.setFieldValue("Address", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.Address && Boolean(formik.errors.Address)}
                                            helperText={formik.touched.Address && formik.errors.Address}
                                        />
                                    </div>
                                    <div className='col-12 col-md-4'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="State"
                                            name="State"
                                            label="State *"
                                            type="text"
                                            value={formik.values.State}
                                            InputLabelProps={{ shrink: true }}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("State", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.State && Boolean(formik.errors.State)}
                                            helperText={formik.touched.State && formik.errors.State}
                                        />
                                    </div>
                                    <div className='col-12 col-md-4'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="City"
                                            name="City"
                                            label="City *"
                                            type="text"
                                            value={formik.values.City}
                                            InputLabelProps={{ shrink: true }}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("City", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.City && Boolean(formik.errors.City)}
                                            helperText={formik.touched.City && formik.errors.City}
                                        />
                                    </div>
                                    <div className='col-12 col-md-4'>
                                        <TextField
                                            variant="standard"
                                            className='mb-3 w-100'
                                            label="Postal Code *"
                                            inputProps={{
                                                maxLength: 6
                                            }}
                                            id="PostalCode"
                                            name="PostalCode"
                                            value={formik.values.PostalCode}
                                            InputLabelProps={{ shrink: true }}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("PostalCode", e.target.value.replace(/[^0-9]/g, ''));
                                            }}
                                            error={formik.touched.PostalCode && Boolean(formik.errors.PostalCode)}
                                            helperText={formik.touched.PostalCode && formik.errors.PostalCode}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="Name"
                                            name="Name"
                                            label="Contact Person Name *"
                                            InputLabelProps={{ shrink: true }}
                                            type="text"
                                            value={formik.values.Name}
                                            onChange={(e) => {
                                                formik.setFieldValue("Name", e.target.value.replace(/[^a-z0-9\s]/gi, ''));
                                            }}
                                            error={formik.touched.Name && Boolean(formik.errors.Name)}
                                            helperText={formik.touched.Name && formik.errors.Name}
                                        />
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <TextField
                                            variant="standard"
                                            className='mb-3 w-100'
                                            label="Mobile Number *"
                                            inputProps={{
                                                maxLength: 10
                                            }}
                                            id="Mobile"
                                            name="Mobile"
                                            value={formik.values.Mobile}
                                            InputLabelProps={{ shrink: true }}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("Mobile", e.target.value.replace(/[^0-9]/g, ''));
                                            }}
                                            error={formik.touched.Mobile && Boolean(formik.errors.Mobile)}
                                            helperText={formik.touched.Mobile && formik.errors.Mobile}
                                        />
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="Email"
                                            name="Email"
                                            label="Email ID *"
                                            type="text"
                                            value={formik.values.Email}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={formik.handleChange}
                                            error={formik.touched.Email && Boolean(formik.errors.Email)}
                                            helperText={formik.touched.Email && formik.errors.Email}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="TellUsAbout"
                                            multiline
                                            rows={2}
                                            name="TellUsAbout"
                                            label="Tell us about your Business *"
                                            type="text"
                                            value={formik.values.TellUsAbout}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("TellUsAbout", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.TellUsAbout && Boolean(formik.errors.TellUsAbout)}
                                            helperText={formik.touched.TellUsAbout && formik.errors.TellUsAbout}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <div className='f12 mb-3'>
                                            <div className='d-flex align-items-center'>
                                                <div><FormGroup>
                                                    <FormControlLabel className='f14' control={<Checkbox className='f14' checked={agree} onChange={haveAgree} />} label="" />
                                                </FormGroup></div>
                                                <div className='fw-bold'>I accept the <Link to="/terms-of-use" target='_blank'>Terms & Privacy Policy</Link></div>
                                            </div>
                                        </div>
                                        {!loading ? <Button color="error"
                                            disabled={!agree}
                                            variant="contained" className='w-100' type="submit">
                                            Submit
                                        </Button> : <LoadingButton className="w-100"
                                            loading
                                            //loadingPosition="end"
                                            variant="contained"
                                        >
                                            Submit...
                                        </LoadingButton>}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ clear: 'both', height: '40px' }}></div>
            <FotterMain />
        </>
    )
}

export default OemRegsitration